import { HedgingSettings } from "./hedgingSettings";
import { loadHedgings } from "./hedgings.actions";
import useLazySelector, { isNotCustomer } from "common/redux/useLazySelector";

const defaultVal: HedgingSettings[] = [];
export default function useHedgingSettings(): HedgingSettings[] {
    return useLazySelector(m => m.hedgingSettings, dispatch => loadHedgings()(dispatch), isNotCustomer, defaultVal);
}